<!--
  Pílulas segmentadas (protótipo 01): "Nome · selo" por sócio e "Consolidado (n sócios)". Os números que os cards
  mostravam (PL e garantia livre, ou dívidas sem política) ficam numa linha pequena dentro da pílula; participação e
  cargo vão no title e no herói.
-->
<nav class="selector" aria-label="Escolher sócio">
  @for (partner of partners(); track partner.personId) {
    <button
      type="button"
      class="selector__pill"
      [class.selector__pill--active]="isSelected(partner.personId)"
      [attr.aria-pressed]="isSelected(partner.personId)"
      [title]="describe(partner)"
      (click)="selectPartner.emit(partner.personId)">
      <span class="selector__line">
        <span class="selector__name">{{ personName(partner.name) }}</span>
        <span class="selector__dot" aria-hidden="true">·</span>
        <span class="pit-tag selector__badge" [class]="badges[partner.badge].css">
          {{ badges[partner.badge].label }}
        </span>
      </span>
      <span class="selector__numbers">
        PL {{ money(partner.netWorth) }} ·
        @if (policyDefined()) {
          Garantia livre {{ money(partner.freeCollateral) }}
        } @else {
          Dívidas {{ debts(partner.personId) }}
        }
      </span>
    </button>
  }

  <button
    type="button"
    class="selector__pill selector__pill--group"
    [class.selector__pill--active]="isConsolidated()"
    [attr.aria-pressed]="isConsolidated()"
    title="Todos os sócios lado a lado e as garantias de cada um"
    (click)="selectConsolidated.emit()">
    <span class="selector__line">
      <span class="selector__name">
        Consolidado ({{ partners().length }} {{ partners().length === 1 ? 'sócio' : 'sócios' }})
      </span>
    </span>
    <span class="selector__numbers">Todos os sócios lado a lado e as garantias de cada um</span>
  </button>
</nav>
